import { useSelector } from 'react-redux';
import AppMenu from 'components/layout/AppMenu/AppMenu';
import ColorChooser from 'components/features/ColorChooser/ColorChooser';
import FenceCanvas from 'components/features/FenceCanvas/FenceCanvas';
import FenceCalculation from 'components/features/FenceCalculation/FenceCalculation';
import style from './AppBody.module.scss';

const AppBody = () => {
  const fence = useSelector((state) => state.fence);

  return (
    <div className={style.body}>
      <AppMenu />

      <div className={style.editor}>
        <div className={style.editor_body}>
          {!fence.readyForCalculation && <ColorChooser />}
          {!fence.readyForCalculation && <FenceCanvas />}
          {fence.readyForCalculation && <FenceCalculation />}
        </div>

        <div className={style.editor_footer}>
          A kép illusztráció. A termék színe, alakja, megjelenése és funkciói csak tájékoztató jellegűek, a valós termék
          ettől eltérhet.
        </div>
      </div>
    </div>
  );
};

export default AppBody;
